const TRACKED_UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

const COOKIE_PREFIX = "udg_";
const COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;

function cookieNameFor(key) {
  return `${COOKIE_PREFIX}${key}`;
}

function readCookie(name) {
  const cookies = document.cookie ? document.cookie.split("; ") : [];
  const match = cookies.find((cookie) => cookie.startsWith(`${name}=`));
  if (!match) return "";

  const value = match.split("=").slice(1).join("=");
  return value ? decodeURIComponent(value) : "";
}

function writeCookie(name, value) {
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax`;
}

function clearCookie(name) {
  document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
}

function normalizeValue(value) {
  return value?.trim() || "";
}

function trackedParamsFromSearch(search = window.location.search) {
  const params = new URLSearchParams(search);

  return TRACKED_UTM_KEYS.reduce((result, key) => {
    const value = normalizeValue(params.get(key));
    if (value) result[key] = value;
    return result;
  }, {});
}

export function getStoredUtmParams() {
  return TRACKED_UTM_KEYS.reduce((result, key) => {
    const value = normalizeValue(readCookie(cookieNameFor(key)));
    if (value) result[key] = value;
    return result;
  }, {});
}

export function captureUtmParamsFromLocation(search = window.location.search) {
  const nextParams = trackedParamsFromSearch(search);
  if (Object.keys(nextParams).length === 0) return getStoredUtmParams();

  TRACKED_UTM_KEYS.forEach((key) => {
    const value = nextParams[key];
    if (value) {
      writeCookie(cookieNameFor(key), value);
    } else {
      clearCookie(cookieNameFor(key));
    }
  });

  return getStoredUtmParams();
}